module.exports = __webpack_public_path__ + "img/complete.c0a90550.svg";